import { makeStyles } from "@material-ui/styles";

const overpassStyles = makeStyles(() => ({
	"@font-face": [
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 100,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9TqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 100,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY93qxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 100,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9bqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 100,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9fqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 100,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9nqxzUKg1o.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 200,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9TqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 200,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY93qxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 200,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9bqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 200,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9fqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 200,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9nqxzUKg1o.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 300,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9TqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 300,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY93qxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 300,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9bqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 300,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9fqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 300,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9nqxzUKg1o.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 400,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9TqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 400,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY93qxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 400,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9bqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 400,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9fqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 400,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9nqxzUKg1o.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 600,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9TqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 600,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY93qxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 600,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9bqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 600,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9fqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 600,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9nqxzUKg1o.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 700,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9TqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 700,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY93qxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 700,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9bqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 700,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9fqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 700,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9nqxzUKg1o.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 800,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9TqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 800,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY93qxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 800,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9bqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 800,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9fqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 800,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9nqxzUKg1o.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 900,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9TqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 900,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY93qxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 900,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9bqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 900,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9fqxzUKg1oCNQ.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "italic",
			fontWeight: 900,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdB35WCmI96Ajtm81GgY9nqxzUKg1o.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 100,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GoU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 100,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GhU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 100,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GqU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 100,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GrU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 100,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GlU9vgwBcI.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 200,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GoU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 200,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GhU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 200,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GqU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 200,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GrU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 200,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GlU9vgwBcI.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 300,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GoU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 300,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GhU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 300,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GqU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 300,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GrU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 300,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GlU9vgwBcI.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 400,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GoU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 400,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GhU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 400,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GqU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 400,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GrU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 400,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GlU9vgwBcI.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 600,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GoU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 600,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GhU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 600,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GqU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 600,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GrU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 600,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GlU9vgwBcI.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 700,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GoU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 700,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GhU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 700,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GqU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 700,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GrU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 700,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GlU9vgwBcI.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 800,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GoU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 800,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GhU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 800,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GqU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 800,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GrU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 800,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GlU9vgwBcI.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 900,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GoU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 900,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GhU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 900,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GqU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 900,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GrU9vgwBcIs1s.woff2) format('woff2')",
			unicodeRange:
				"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
		},
		{
			fontFamily: "'Overpass'",
			fontStyle: "normal",
			fontWeight: 900,
			fontDisplay: "swap",
			src: "url(https://fonts.gstatic.com/s/overpass/v12/qFdH35WCmI96Ajtm81GlU9vgwBcI.woff2) format('woff2')",
			unicodeRange:
				"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
		}
	]
}));

export default overpassStyles;
